import { Button } from '@welbe/design-system';
import { Container, Description } from './VerificationCode.styles';
import React, { Fragment } from 'react';
import { InputCode } from '../shared/components/InputCode';
import { useVerificationCode } from './VerificationCode.hooks';
import { SuccessInfo } from './SuccessInfo/SuccessInfo';

export const VerificationCode = () => {
	const {
		isSuccess,
		isLoading,
		user,
		isLoginLoading,
		buttonText,
		handleBack,
		setCode,
		handleSubmit,
		handleResendCode,
	} = useVerificationCode();

	return (
		<Container id="authentication-form" success={isSuccess}>
			{isSuccess ? (
				<SuccessInfo loading={isLoading} />
			) : (
				<Fragment>
					<Description>
						<p>Hola,</p>
						<p>
							enviamos un código de verificación al correo electrónico{' '}
							<strong>{user.email}</strong>.
						</p>
					</Description>
					<InputCode
						resendCodeVisible={user.type === 'confirmation'}
						length={6}
						label="Introduzca el código recibido en el correo electrónico"
						loading={false}
						onComplete={(code: any) => setCode(code)}
						onResendCode={handleResendCode}
					/>
					<Button
						width="200px"
						className="submit-button"
						onClick={handleSubmit}
						disabled={isLoading || isLoginLoading}
						loading={isLoading || isLoginLoading}
					>
						{buttonText[user.type]}
					</Button>
					{user.type === '2fa' && (
						<Button
							width="200px"
							variant="ghost"
							onClick={handleBack}
							disabled={isLoading || isLoginLoading}
						>
							Regresar
						</Button>
					)}
				</Fragment>
			)}
		</Container>
	);
};
